export default __webpack_public_path__ + "static/media/carto-logo-negative.fd0007ce.svg";